import React from "react";

function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="423" height="600" viewBox="0 0 423 600">
      <path fill="#fff" d="M-1 -1H424V601H-1z"></path>
      <g
        fill="none"
        stroke="#000"
        strokeLinecap="undefined"
        strokeLinejoin="undefined"
        strokeWidth="7"
      >
        <path
          fillOpacity="null"
          strokeOpacity="null"
          d="M55 52.666L241 52.666"
        ></path>
        <path
          fillOpacity="null"
          strokeOpacity="null"
          d="M57.335 522.664L57.335 50.894"
        ></path>
        <path
          fillOpacity="null"
          strokeOpacity="null"
          d="M55 521.331L356 521.331"
        ></path>
        <path
          fillOpacity="null"
          strokeOpacity="null"
          d="M354 162.666L354 523"
        ></path>
        <path
          fillOpacity="null"
          strokeOpacity="null"
          d="M354 165.999L237.665 50.997"
        ></path>
        <path d="M240.001 168L240.001 55"></path>
        <path d="M238 166.666L353.344 166.666"></path>
      </g>
    </svg>
  );
}

export default Icon;


// WEBPACK FOOTER //
// ./src/components/Icons/File.jsx